<template>
  <div class="carrot">

    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">푸시관리</h3>
              <p class="lead">
                - 앱을 설치한 사용자에게 푸시알림을 보낼 수 있습니다.<br>
                - 아이폰에서는 푸시제목, 푸시내용만 표시됩니다
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="table-responsive text-center">
                    <table class="table table-bordered">
                      <thead>
                      <tr>
                        <th width="60">발송일시</th>
                        <td>
                          <input v-model="filter.date" type="date" class="form-control" id="colFormLabel"
                                 placeholder="검색어를 입력하세요.">
                        </td>
                        <th>푸시제목</th>
                        <td>
                          <input @keyup.enter="getPushes(1)" v-model="filter.title" type="text" class="form-control" id="colFormLabel"
                                 placeholder="검색어를 입력하세요.">
                        </td>
                      </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="text-right mt-2">
                    <button type="submit" class="btn btn-primary" @click="getPushes(1)">검색</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <button type="submit" class="btn btn-primary fr ml-10" @click="$router.push('/pushadd')">등록</button>
                  </div>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-hover table-bordered">
                      <tr>
                        <th style="width: 5%">No</th>
                        <th style="width: 5%">상태</th>
                        <th style="width: 10%">발송일시</th>
                        <th style="width: 5%">총발송</th>
                        <th style="width: 5%">안드로이드</th>
                        <th style="width: 5%">아이폰</th>
                        <th style="width: 5%">수신확인</th>
                        <th style="width: 5%">발송대상</th>
                        <th style="width: 10%">사용이력</th>
                        <th>푸시제목</th>
                        <th style="width: 5%">HQ매니저</th>
                      </tr>
                      <tr v-for="(item,index) in pushes" :key="item.idx">
                        <td>{{ (result.total - (result.currentPage - 1) * result.perPage  ) - index }}</td>
                        <td>{{ item.statusString }}</td>
                        <td>{{ $moment(item.pushDate).format('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td>{{ item.deviceCount }}</td>
                        <td>{{ item.android }}</td>
                        <td>{{ item.ios }}</td>
                        <td>{{ item.checked }}</td>
                        <td>{{ item.targetUserString }}</td>
                        <td>{{ item.targetDateString }} <span v-if="item.targetDate !== 'A'">({{item.targetSdate}} ~ {{item.targetEdate}})</span></td>
                        <td><a :href="'/pushview/' + item.idx">{{ item.title }}</a></td>
                        <td v-if="item.emp !== null">{{ item.emp.englishname }}({{ item.emp.koreanname }})</td>
                        <td v-else>시스템</td>
                      </tr>
                      <tr v-if="pushes.length === 0">
                        <td colspan="11">검색하신 푸시 내역이 존재하지 않습니다.</td>
                      </tr>
                    </table>

                    <div v-if="lastpage !== 0" style="padding-left:40%; padding-top:20px;">
                      <paginate
                          :page-count="lastpage"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="clickCallback"
                          :prev-text="'Prev'"
                          :next-text="'Next'"
                          :container-class="'pagination'"
                          :page-class="'page-link'">
                      </paginate>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../components/inc_menu.vue'
import Paginate from "vuejs-paginate";

export default {
  name: 'push',
  components: {
    Menu,
    Paginate,
  },
  props: {
    msg: String
  },
  data: () => ({
    filter: {
      page: 1,
      data: '',
      title: ''
    },
    total:0,
    pushes: [],
    lastpage: 1,
  }),
  mounted() {
    this.initPage();
  },
  methods: {
    initPage: function () {
      this.getPushes(1);
    },
    clickCallback: function (pageNum) {
      this.getPushes(pageNum);
    },
    getPushes: function (page) {
      if(page !== undefined) this.filter.page = page;
      var params = {
        page: this.filter.page,
        title: (this.filter.title === '') ? null : this.filter.title,
        date: (this.filter.date === '') ? null : this.filter.date
      };

      this.axios.get(this.$store.state.host + "/v1/admin/pushes", {params})
      .then((res) => {
        if(res.data.status === 105){
          this.pushes = [];
          this.lastpage = 0;
        }else{
          this.result = res.data.result;
          this.pushes = res.data.result.value;
          this.lastpage = res.data.result.lastPage;
        }
      });
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">

</style>
